import { Component,ViewChild,ElementRef,Input,Output,EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyBoolean, OrderDetailsNew } from '../../models/order.models';
import {FormsModule} from '@angular/forms';
import Viewer from 'viewerjs'
import 'viewerjs/dist/viewer.css';
import { MagnifierComponent } from '../magnifier/magnifier.component';
declare const bootstrap: any;
@Component({
  selector: 'app-abutment-gingival',
  standalone: true,
  imports: [CommonModule,FormsModule,MagnifierComponent],
  templateUrl: './abutment-gingival.component.html',
  styleUrl: './abutment-gingival.component.css'
})

export class AbutmentGingivalComponent {
  @Input() orderDetailsNew!: OrderDetailsNew;
    @Input() showSlider: MyBoolean | undefined;
    @Input() readonly: boolean = false;
    @Input() anterior!: boolean;
    @Input() teeth!: number[];
   @Input() abutmentSelectedTeeth: number[] = [];
  @ViewChild('gbridgestrong',{static: false}) gbridgestrong!: ElementRef<HTMLElement> ; 
  @ViewChild('abutmentStep1',{static: false}) abutmentStep1!: ElementRef<HTMLElement> ; 
  @ViewChild('abutmentStep2',{static: false}) abutmentStep2!: ElementRef<HTMLElement> ; 

  @Output() abutmentStep1Change = new EventEmitter<string>();

  activeTooltip = '';

ngOnInit() {
    if(this.orderDetailsNew){
      // this.orderDetailsNew.toothData.find(t => t.teeth === this.abutmentSelectedTooth)['abutmentStep1'] = this.orderDetailsNew.toothData.find(t => t.teeth === this.abutmentSelectedTooth)['abutmentStep1']?this.orderDetailsNew.toothData.find(t => t.teeth === this.abutmentSelectedTooth)['abutmentStep1']:'';
      // this.orderDetailsNew.props['a-Mesial and distal contact point-'+this.anterior] = this.orderDetailsNew.props['a-Mesial and distal contact point-'+this.anterior] ? this.orderDetailsNew.props['a-Mesial and distal contact point-'+this.anterior] : this.q1DefaultValue;
      // this.orderDetailsNew.props['a-Occlusal contact-'+this.anterior] = this.orderDetailsNew.props['a-Occlusal contact-'+this.anterior] ? this.orderDetailsNew.props['a-Occlusal contact-'+this.anterior] : this.q2DefaultValue;
    }
  }

  ngAfterViewInit(): void {
    const img = this.gbridgestrong.nativeElement;
    const viewer = new Viewer(img, {
      inline: false,
      toolbar:false,
      navbar:false,
      button:true,
      zoomOnTouch:true,
      zIndexInline:3,
      zIndex:2147483647,
    });
  }

  
  
 get isAbutmentNarrowSelected(): boolean {

  return this.abutmentSelectedTeeth.some(tooth => {
    const targetTooth = this.orderDetailsNew.toothData.find(t => t.teeth === tooth);
    return targetTooth?.['abutmentStep1'] === "Narrow healing space";
  });

}
  
get isAbutmentHighlySelected(): boolean {

  return this.abutmentSelectedTeeth?.some(tooth => {
    const targetTooth = this.orderDetailsNew.toothData.find(t => t.teeth === tooth);
    return targetTooth?.['abutmentStep1'] === "Highly placed implant";
  }) ?? false;

}
  
onAabutmentStep1Selection(option: string) {

  this.abutmentSelectedTeeth.forEach(tooth => {
    const targetTooth = this.orderDetailsNew.toothData.find(t => t.teeth === tooth);

    if (targetTooth) {
      targetTooth['abutmentStep1'] = option;
    }
  });

  this.abutmentStep1Change.emit(option);
}

shouldBeCheckedForTooth(step: string, value: string): boolean {

  if (!this.abutmentSelectedTeeth?.length) return false;

  const toothData = this.orderDetailsNew.toothData.find(
    t => t.teeth === this.abutmentSelectedTeeth[0]
  );

  return toothData?.[step] === value;
}

}
